import 'whatwg-fetch/dist/fetch.umd.js';
import 'promise-polyfill/dist/polyfill';
import isProject from '../selectors/isProject';
import forEachElement from '../selectors/forEachElement';

export default function submitForm(url, body, method = 'POST', grade = 0) {
  return fetch(
    url,
    {
      body,
      method,
      mode: 'cors',
      credentials: 'omit',
      redirect: 'follow'
    }
  ).then(response => {
    if (String(response.status).slice(0, 2) === '20') { // status 20x
      return Promise.resolve(response);
    } else {
      if(isProject('vt_virtual_learning_hagrid') && response.status == 409) {
        handleDuplicateEmail(grade);
      }
      const error = new Error(`Error code ${response.status} from Leadform API`);
      error.response = response;
      return Promise.reject(error);
    }
  });
}

function handleDuplicateEmail(grade){
  const gradeUrl = gradeUrls[grade];
  const loginUrl = `/login?return_to=${encodeURIComponent(gradeUrl)}`;
  forEachElement('.error_message', el => el.innerHTML =
    `An account already exists for this user. 
     Please <a href=${loginUrl}>sign in</a> or enter a different email address`
  );
}

const gradeUrls = {
  0: '/virtual-kindergarten',
  1: '/virtual-1st-grade',
  2: '/virtual-2nd-grade',
  3: '/virtual-3rd-grade',
  4: '/virtual-4th-grade',
  5: '/virtual-5th-grade',
  6: '/virtual-6th-grade',
  7: '/virtual-7th-grade',
  8: '/virtual-8th-grade',
  9: '/virtual-9th-grade',
  10: '/virtual-10th-grade',
  11: '/virtual-11th-grade',
  12: '/virtual-12th-grade'
};



// WEBPACK FOOTER //
// ./client/app/scripts/principles/form/submitForm.js